import React, { FC, useEffect, useState } from 'react';

import { Range, Transforms, Node } from 'slate';
import { useSlate } from 'slate-react';

//components
import ConfirmPrompt from '../../../../components/modals/confirmPrompt';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../constants/aampeTheme';

import { ElementKind } from '../../../../models/editor.model';

//models
import { ToggleButtonValues } from '../FormulaEditorMain';

interface VariantDeletePromptProps {
    currentSelection: Range;
    setIsVariationTab: (value: ToggleButtonValues) => void;
    setSelectedElement: (value?: { [key: string]: any }) => void;
}
const VariantDeletePrompt: FC<VariantDeletePromptProps> = ({
    currentSelection,
    setIsVariationTab,
    setSelectedElement,
}) => {
    const editor = useSlate();
    const [isVariantDeleting, setIsVariantDeleting] = useState<boolean>(false);

    useEffect(() => {
        if (currentSelection) {
            const hasNode: boolean = Node.has(
                editor,
                currentSelection.anchor.path,
            );
            if (hasNode) {
                const node: any = Node.get(
                    editor,
                    currentSelection.anchor.path,
                );
                if (node.kind === ElementKind.variant) {
                    setIsVariantDeleting(true);
                }
            }
        }
    }, [currentSelection, setIsVariantDeleting, editor]);

    const confirmVariantDelete = () => {
        if (currentSelection) {
            const variantNodePath = [...currentSelection.anchor.path];
            const updatedPath =
                variantNodePath.length === 3
                    ? variantNodePath.slice(0, 2)
                    : variantNodePath;
            Transforms.removeNodes(editor, { at: updatedPath });
            if (setIsVariationTab)
                setIsVariationTab(ToggleButtonValues.PREVIEW);

            if (setSelectedElement) setSelectedElement(undefined);
        }
    };

    const handleCancel = () => {
        setIsVariantDeleting(false);
    };
    return (
        <ConfirmModalContainer>
            {isVariantDeleting ? (
                <ConfirmPrompt
                    message={'Are you sure you want to delete this component?'}
                    description={`Any alternates that you've created below will be lost.`}
                    type={'warning'}
                    confirm="Delete"
                    abortHandler={handleCancel}
                    confirmHandler={confirmVariantDelete}
                    style={{ marginBottom: aampeTheme.spacing(2) }}
                />
            ) : null}
        </ConfirmModalContainer>
    );
};

const ConfirmModalContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
});
export default VariantDeletePrompt;
